import styled from 'styled-components';
import type { InsightParagraphBlock } from '../../types';

const Paragraph = styled.p<{ $lead?: boolean; $ink: string; $mutedInk: string }>`
  max-width: 46rem;
  margin: 0 auto;
  color: ${({ $lead, $ink, $mutedInk }) => ($lead ? $ink : $mutedInk)};
  font-family: ${({ $lead }) => ($lead ? 'var(--font-serif)' : 'inherit')};
  font-size: ${({ $lead }) => ($lead ? 'clamp(1.35rem, 2.5vw, 1.9rem)' : '1.05rem')};
  line-height: ${({ $lead }) => ($lead ? '1.42' : '1.82')};
  letter-spacing: ${({ $lead }) => ($lead ? '-0.02em' : '0')};
`;

type ParagraphBlockProps = {
  block: InsightParagraphBlock;
  ink: string;
  mutedInk: string;
};

export default function ParagraphBlock({ block, ink, mutedInk }: ParagraphBlockProps) {
  return (
    <Paragraph $lead={block.lead} $ink={ink} $mutedInk={mutedInk}>
      {block.text}
    </Paragraph>
  );
}
